import { RuleResult } from '../../../../types/DeclarationP5'

const C0939Validator = {
  validateContainerPackedStatus: ({
    security,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType: string
  }): RuleResult => {
    if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

    return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
  },
}

export default C0939Validator
